import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { PartnersTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
};

export const schemaPartnerResolver_GetPartner = PartnersTableDefinitionZod.nullable();

export type SchemaPartnerResolver_GetPartner = z.infer<typeof schemaPartnerResolver_GetPartner>;
export type PartnerResolver_GetPartner = Resolver<Arguments, SchemaPartnerResolver_GetPartner>;
